var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"poptxt-wrap",staticStyle:{"display":"block"}},[(_vm.textInfo[_vm.textIndex])?_c('p',{staticClass:"text_msg",domProps:{"innerHTML":_vm._s(_vm.textInfo[_vm.textIndex][0])}}):_vm._e(),_c('div',{staticClass:"tips-closetxt",staticStyle:{"z-index":"9999"},on:{"click":_vm.closeHot}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }